export default __webpack_public_path__ + "images/XP.dd40d70.png";